import { environment } from "src/environments/environment";
const urlConstants = environment.url
export const gisVassarlabsStoreName = 'HEATWAVE';
export const gisIP = environment.url.NEW_GEOSERVER_URL;
export const gisStoreName = 'HEATWAVE';
export const gisBaseUrl = gisIP + gisStoreName + '/wms/';
export const gisIPKwaramGeo = environment.url.NEW_GEOSERVER_URL;
export const gisGeoUrl = urlConstants.NEW_GEOSERVER_URL + gisVassarlabsStoreName + '/wms/';
export const gisBaseUrlForServices = gisIP + gisStoreName + '/ows';
export const MapConstants = {

  MIN_ZOOM: 6,
  MAX_ZOOM: 11,
  ZOOM_SNAP: 1,
'ANDHRA PRADESH_CENTER': [20.5937, 78.9629],

  LAYERKEY_SOURCE_MAP: {
      "Sentinel 1": "SENTINEL_1",
      "Sentinel 2 FCC": "SENTINEL_2",
      "Sentinel 2 TCC": "SENTINEL_2"    
  },
  SOURCE_COORDINATE_MAP: {
      "SENTINEL_1":[{
        point : { x: 665, y: 352},
        bbox : "78.39294433593751,18.665762138680716,79.00474548339845,18.838714379258032",
        size : { y : 532, x: 1782}
      },
      {
        point : { x: 1064, y: 412},
        bbox : "76.937255859375,18.012691932112393,81.83166503906251,19.396658607621557",
        size : { y : 532, x: 1782}
      }
      ],
      "SENTINEL_2":[{
        point : { x: 776, y: 247 },
        bbox : "73.26232910156251,17.046281225389077,83.05114746093751,19.81839009384496",
        size : { y : 532, x: 1782}
      },{
        point : { x: 665, y: 352},
        bbox : "78.39294433593751,18.665762138680716,79.00474548339845,18.838714379258032",
        size : { y : 532, x: 1782}
      },
      {
        point : { x: 1227, y: 421},
        bbox : "74.43786621093751,16.99375545289456,84.19372558593751,19.766703551716976",
        size : { y : 532, x: 1782}
      }
    ]
  },
  BASELAYER_METADATA_LAYER:{
      "BASELAYER_METADATA" : {
        name: "BASELAYER_METADATA",
        visible: false,
        layeroptions_name: "kaleshwaram:baselayer_metadata",
        layeroptions_min_zoom: 1,
        layeroptions_max_zoom: 18,
        layeroptions_show_on_selector: false,
        layeroptions_pane : 'elev',
        type: "WMS",
        cql_filter : null,
        group : null,
      }
  },
  SOURCE_DEPTH_LAYER_MAP : {
    "SENTINEL_1" : "Depth_Class",
    "SENTINEL_2" : "Depth_Class_Sentinel2",
    "SENTINEL1" : "Depth_Class",
    "SENTINEL2" : "Depth_Class_Sentinel2"
  },
  GEOSERVER_WORKSPACE_NAME: "tamilnadu",
  GEOSERVER_WMTS_URL: environment.url.NEW_GEOSERVER_URL+"gwc/service/wmts?tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/vnd.mapbox-vector-tile&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  GEOSERVER_WMS_URL: environment.url.NEW_GEOSERVER_URL+"ows/wms",
  GEOJSON_LAYER_URL: environment.url.NEW_GEOSERVER_URL+"HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson",
  GEOSERVER_WMFS_URL: environment.url.NEW_GEOSERVER_URL+"HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson&typeName=",
  KALESHWARAM_WORKSPACE_NAME : "HEATWAVE",
  KALESHWARAM_GEOJSON_LAYER_URL: environment.url.NEW_GEOSERVER_URL+"HEATWAVE/ows?service=WFS&version=1.0.0&request=GetFeature&maxFeatures=50&outputFormat=application%2Fjson",

  PANE_LIST: [{
    name: 'base',
    zindex: '390'
  },
  {
    name: 'WA',
    zindex: '395'
  },
  {
    name: 'state',
    zindex: '404'
  },
  {
    name: 'district',
    zindex: '405'
  },
  {
    name: 'block',
    zindex: '406'
  },
  {
    name: 'wind',
    zindex: '900'
  },
  {
    name: 'heatMap',
    zindex: '395'
  },
  {
    name: 'marker',
    zindex: '600'
  },
  {
    name: 'popUp',
    zindex: '605'
  },
  {
    name: 'popUpGeoJson',
    zindex: '630'
  }
  ]
}
export const AlertMapConstants = {
  GEOJSON_URL: '/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application/json&maxFeatures=10000',
  Geoserver_Workspace: 'HEATWAVE',
  GeoJSON_Pre_url: '/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=HEATWAVE:',
  geoJson_post_url: '&maxFeatures=5000000&outputFormat=application%2Fjson',
  SELF_CATCHMENT_LAYER_NAME :{
    CITY : 'AP_CITIES_CATCHMENTS',
    MITANK : 'AP_MITANKS_CATCHMENTS',
    FORECAST_POINTS : 'AP_FULL_CATCHMENTS',
    RIVER_GAUGE : 'AP_FULL_CATCHMENTS',
    RESERVOIR : 'AP_FULL_CATCHMENTS'
  },
  FloodForecastMapOptions: {   //changed for India
    // southZone: {
    //   minZoom: 1,
    //   maxZoom: 18,
    //   zoom: 6,
    //   // center: [16.403274736612818, 78.83789062500001],
    //   center: [20.5937, 78.9629],
    //   zoomControl: false,
    //   zoomAnimation: true,
    //   shpBoundaryOptions: {
    //     layerName: 'SOUTHZONE_BOUNDARY'
    //   }
    //   // preferCanvas : true
    // }
    southZone: {
        minZoom: 6,
        maxZoom: 18,
        zoom: 7,
        center: [16.403274736612818, 78.83789062500001],
        zoomControl: true,
        zoomAnimation: true,
        shpBoundaryOptions: {
          layerName: 'SOUTHZONE_BOUNDARY'
        },
        maxBoundsViscosity: 1.0,
        scrollWheelZoom: false,
        attributionControl: false
        // preferCanvas : true
      },
  },
  FloodForecastBaseLayerOptions: {
    // 'Base Layer': {
    //   url: environment.url.NEW_GEOSERVER_URL + 'gwc/service/wmts?layer=baselayer:floodforecast_base_layer&style&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
    //   options: {
    //     maxZoom: 22,
    //     visible: true,
    //     group: 'group1',
    //     legendData: {
    //       title: 'BASE LAYER',
    //       image: 'img/newGeoportal/legends/base_layer_legend_image.png'
    //     },
    //     imagesrc: '../../../../../../assets/imgs/base-map.jpg',
    //   }
    // },
    // Stamen: {
    //   url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png',
    //   options: {
    //     maxNativeZoom: 14,
    //     maxZoom: 14,
    //     group: 'group1',
    //     visible: false,
    //     imagesrc: '../../../../../../assets/imgs/open-street.jpg',
    //   }
    // },
    Carto: {
      url: 'http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
      options: {
        maxZoom: 22,
        group: 'group1',
        visible: true,
        imagesrc: '../../../../../../assets/imgs/base-map.jpg',
      }
    },
    'Google Satellite': {
      url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      options: {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        group: 'group1',
        visible: false,
        imagesrc: '../../../../../../assets/imgs/satellite.jpg',
      }
    },
    'Open Street Maps': {
      url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        maxZoom: 22,
        maxNativeZoom: 18,
        group: 'group1',
        visible: false,
        imagesrc: '../../../../../../assets/imgs/open-street.jpg',
      }
    }
  },
  FloodForecastMapPanes: [
    {
      name: 'group0',
      zIndex: 580
    },
    {
      name: 'group1',
      zIndex: 581
    },
    {
      name: 'group2',
      zIndex: 582
    },
    {
      name: 'group3',
      zIndex: 583
    },
    {
      name: 'group4',
      zIndex: 584
    },
    {
      name: 'group5',
      zIndex: 585
    },
    {
      name: 'group6',
      zIndex: 588
    }
  ],
  floodforecastRiver: {
    Flood_Alerts: {
        type:'colorScale',
        units: '',
        colorValues: [
          
          {
            backgroundColor: '#008021',
            color: '#000000',
            text: 'No Warning'
          },
          {
            backgroundColor: '#FFFD50',
            color: '#000000',
            text: 'Caution'
          },
          {
            backgroundColor: '#FFA135',
            color: '#000000',
            text: 'Warning'
          },
          {
            backgroundColor: '#FF0019',
            color: '#fff',
            text: 'Danger'
          },
          {
            backgroundColor: '#910018',
            color: '#fff',
            text: 'Extreme Danger'
          }     
        ]

    },
    ObservedDaily: {
      type:'colorScale',
      units: 'Rainfall in mm',
      colorValues: [
        
        {
          backgroundColor: '#008021',
          color: '#000000',
          text: '0.3 - 15.6'
        },
        {
          backgroundColor: '#FFFD50',
          color: '#000000',
          text: '15.7 - 64.5'
        },
        {
          backgroundColor: '#FFA135',
          color: '#000000',
          text: '64.6 - 115.6'
        },
        {
          backgroundColor: '#FF0019',
          color: '#fff',
          text: '115.7 - 300.0'
        },
        {
          backgroundColor: '#910018',
          color: '#fff',
          text: '>300'
        }     
      ]
    },
    ObservedHourly: {
    type:'colorScale',
    units: 'Rainfall in mm',
    colorValues: [
      
      {
        backgroundColor: '#008021',
        color: '#000000',
        text: '0.0 - 4.0'
      },
      {
        backgroundColor: '#FFFD50',
        color: '#000000',
        text: '4.1 - 16.0'
      },
      {
        backgroundColor: '#FFA135',
        color: '#000000',
        text: '16.1 - 30.0'
      },
      {
        backgroundColor: '#FF0019',
        color: '#fff',
        text: '30.1 - 100.0'
      },
      {
        backgroundColor: '#910018',
        color: '#fff',
        text: '>100'
      }     
    ]
    },
    forecastHourly: {
      type:'colorScale',
      units: 'Rainfall in mm',
      colorValues: [
        
        {
          backgroundColor: '#008021',
          color: '#000000',
          text: '0.0 - 7.0'
        },
        {
          backgroundColor: '#FFFD50',
          color: '#000000',
          text: '7.1 - 28.0'
        },
        {
          backgroundColor: '#FFA135',
          color: '#000000',
          text: '28.1 - 52.2'
        },
        {
          backgroundColor: '#FF0019',
          color: '#fff',
          text: '52.3 - 168.8'
        },
        {
          backgroundColor: '#910018',
          color: '#fff',
          text: '>168.8'
        }     
      ]
    },
    alert_icons: {
      units: 'Legends',
      colorValues: [
        
        {
          image:'../assets/imgs/alert-icons/reservoir_no_data.svg',
          text: 'Reservoir'
        },
        {
          image:'../assets/imgs/alert-icons/river_gauges_no_data.svg',
          text: 'River Gauges'
        },
        {
          image:'../assets/imgs/alert-icons/mi_tanks_no_data.svg',
          text: 'MI Tanks'
        },
        {
          image:'../assets/imgs/alert-icons/cities_no_data.svg',
          text: 'Cities'
        },
        {
          image:'../assets/imgs/alert-icons/river_network.png',
          text: 'River Network'
        },
        {
          image:'../assets/imgs/alert-icons/district_border.png',
          text: 'District Boundary'
        },
        {
          image:'../assets/imgs/alert-icons/state_border.png',
          text: 'State Boundary'
        } 
      ]

  },
  },

  IMD_START_TIME: {
    hours: 5,
    minutes: 30,
    seconds: 0
},

ECMWF_START_TIME: {
    hours: 5,
    minutes: 30,
    seconds: 0
},
forecastHeatMapOptions: {
  type: 'Time',
  time: '24',
  isImageClip: true,
  view: 'Admin',
  serviceType: 'HeatMap'
},

HeatMapOptions: {
  type: 'Time',
  time: '24',
  clip: true,
  view: 'Admin',
  serviceType: 'HeatMap'
},

Default_HeatMap_Layer_Constant: {
  id: 'RAINFALL_HEATMAP',
  name: 'Heatmap',
  type: 'Image',
  isImageClip: true,
  key:'InflowForecastHeatMap',
  applications: ['inflowforecast'],
  options: {
      "name": "Rainfall Heatmap Layer",
      "component": "RAINAFALL",
      "hasLegend": false,
      // 'legendName': 'Rainfall Forecast',
      "displayName": "Rainfall Heatmap Layer",
      "visible": false,
      "group": "Rainfall Forecast",
      "groupType": "radio-deselect",
      "type": "HEATMAP",
      "layerName": "Rainfall Heatmap",
      "pane": 'heatMap',
      "minZoom": 6,
      "maxZoom": 15,
  }
},
SourceToDayCount: {
  IMD: 8,
  ECMWF: 8,
  NCMRWF: 2,
  IBM_GRAF: 7
},

  LegendActual: {
    colorValues: [
        {
            imgurl: 'assets/img/rainfall-legend/rf-7.png',
            text: '0'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-6.png',
            text: '0.1'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-5.png',
            text: '2.5'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-4.png',
            text: '15.6'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-3.png',
            text: '64.5'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-2.png',
            text: '115.6'
        },
        {
            imgurl: 'assets/img/rainfall-legend/rf-1.png',
            text: '>=204.5'
        }
    ],
    units: 'mm',
    title: 'Rainfall in'
},

  RainfallLegend: {
    LOW: {
      legendData: {
        levels: [
          {
            name: '0.0-0.1',
            color: '#FFFFFF',
          },
          {
            name: '0.1-2.5',
            color: '#C3FDCA',
          },
          {
            name: '2.5-15.6',
            color: '#01FF04',
          },
          {
            name: '15.6-64.5',
            color: '#048500',
          },
          {
            name: '64.5-115.6',
            color: '#FDC0CB',
          },
          {
            name: '115.6-204.5',
            color: '#FC0300',
          },
          {
            name: '>204.5',
            color: '#610301'
          }
        ]
      }
    },
    HIGH: {
      legendData: {
        levels: [
          {
            name: '0.0-0.25',
            color: '#DEDEDD',
          },
          {
            name: '0.25-25',
            color: '#D1FCC4',
          },
          {
            name: '25-65',
            color: '#97E994',
          },
          {
            name: '65-125',
            color: '#2D9D31',
          },
          {
            name: '125-250',
            color: '#FDA3A5',
          },
          {
            name: '250-400',
            color: '#FEBF02',
          },
          {
            name: '400-600',
            color: '#9C34C7',
          },
          {
            name: '600-1500',
            color: '#951828',
          },
          {
            name: '>1500',
            color: '#AFA5FC',
          }
        ]
      }
    }
  },

  rainfallLegendValues:
  {
    LOW: [
      {
        level: 0.1,
        color: '#FFFFFF',
      },
      {
        level: 2.5,
        color: '#C3FDCA',
      },
      {
        level: 15.6,
        color: '#01FF04',
      },
      {
        level: 64.5,
        color: '#048500',
      },
      {
        level: 115.6,
        color: '#FDC0CB',
      },
      {
        level: 204.5,
        color: '#FC0300',
      },
      {
        level: 10000,
        color: '#610301'
      }
    ],
    HIGH: [
      {
        level: 0.25,
        color: '#DEDEDD',
      },
      {
        level: 25,
        color: '#D1FCC4',
      },
      {
        level: 65,
        color: '#97E994',
      },
      {
        level: 125,
        color: '#2D9D31',
      },
      {
        level: 250,
        color: '#FDA3A5',
      },
      {
        level: 400,
        color: '#FEBF02',
      },
      {
        level: 600,
        color: '#9C34C7',
      },
      {
        level: 1500,
        color: '#951828',
      },
      {
        level: 1000000,
        color: '#AFA5FC',
      }

    ]
  }
};

export const VisibilityMapConstants = {

  LOCATIONS: {
    'TELANGANA': 'TELANGANA',
    'GODAVARI': 'GODAVARI',
    'INDIA': 'INDIA',
    "STATE": "STATE",
    "DISTRICT": "DISTRICT",
    "MANDAL": "MANDAL",
    "MITANK": "MITANK",
    "RAINFALL": "RAINFALL",
    "GROUNDWATER": "GROUNDWATER",
    'BASIN': 'BASIN',
    'SUBBASIN': 'SUBBASIN',
    'ALL': 'ALL',
    'STATION': 'STATION',
    'BASIN_LAST_LEVEL': 'BASIN_LAST_LEVEL',
    'RESERVOIR': 'RESERVOIR',
    'ANDHRAPRADESH' : 'ANDHRAPRADESH',
    'RIVER_GAUGE': 'RIVER_GAUGE',
    'CANAL': 'CANAL',
    'SUB_CANAL': 'SUB_CANAL',
    'DISTRIBUTARY_CANAL': 'DISTRIBUTARY_CANAL',
    'MINOR': 'MINOR',
    'SUB_MINOR': 'SUB_MINOR',
    'VILLAGE': 'VILLAGE',
    'COMMAND_AREA': 'COMMAND_AREA',
    'RESERVOIR_INITIAL':'RESERVOIR_INITIAL',
    'RESERVOIR_NEXTLEVEL':'RESERVOIR_NEXTLEVEL',
    'SUB_COMMAND_AREA': 'SUB_COMMAND_AREA',
    'COMMAND_DISTRICT': 'COMMAND_DISTRICT',
    'COMMAND_MANDAL': 'COMMAND_MANDAL',
    'TAMILNADU': 'TAMILNADU',
    'ODISHA': 'ODISHA',
    'INFLOWFORECAST': 'INFLOWFORECAST',
    'BLOCK': 'BLOCK',
    'COUNTRY': 'COUNTRY',
    'HEATMAP': 'HEATMAP',
    "TALUK":"TALUK",
    "FIRKA":"FIRKA",
  },
  VIEWS: {
    'ADMIN': 'ADMIN',
    'BASIN': 'BASIN',
    'ALL': 'ALL',
  },
  COMPONENT: {
    'RAINFALL': 'RAINFALL',
    'ALERT' : 'ALERT'
  },
  SOURCES: {
    'ALL': 'ALL',
    'SENTINEL1': 'SENTINEL1',
    'SENTINEL2': 'SENTINEL2',
    'TELANGANA_MITANK': 'TELANGANA_MITANK',
    'TELANGANA_MITANK_BY_DEPT': 'TELANGANA_MITANK_BY_DEPT',
    'SENTINEL1_DEM': 'SENTINEL1_DEM',
    'SENTINEL2_DEM': 'SENTINEL2_DEM',
    'Combined_S1S2': 'Combined_S1S2',
    'Combined_S1S2_DEM': 'Combined_S1S2_DEM',
    'SENTINEL2_GC': 'SENTINEL2_GC',
    'SENTINEL1_GC': 'SENTINEL1_GC',
    'STATE_AND_CENTRAL_STATIONS': 'STATE_AND_CENTRAL_STATIONS',
    'TELANGANA_GW': 'TELANGANA_GW',
    'CGWB': 'CGWB',
    'STATE_STATIONS': 'STATE_STATIONS',
    'GEOSERVER': 'GEOSERVER',
    'BACKEND': 'BACKEND',
    "IMD_GRID": 'IMD_GRID',
    'GRID': 'GRID',
    "NRSC": "NRSC",
    "IMD_STATIONS": "IMD_STATIONS",
    "TNSMART" : "TNSMART",
    "TNPWD": "TNPWD GW",
    "SG&SWRDC": "SG&SWRDC",
    "TNAU" : "TNAU",
    "GPM_GRID": "GPM_GRID",
    "TNPCB_RIVER":"TNPCB_RIVER",
    "ALL_STATIONS":"ALL_STATIONS",
    "TWAD":"TWAD",
    'NHP_GW' : 'NHP_GW',
    "TNPCB" : "TNPCB",
    "VIC" : "VIC"
 
  },
  IDTOSTATENAMEMAPPING: {
    akbm: 'ANDHRA PRADESH',
    chka: 'KARNATAKA',
    maks: 'KERALA',
    dvaj: 'ORISSA',
    kskc: 'TELANGANA',
    tn: 'TAMILNADU'
  },
  LOCATION_CONSTANT: {
    COUNTRY: "COUNTRY",
    STATE: "STATE",
    DISTRICT: "DISTRICT",
    BLOCK: "BLOCK",
    MANDAL: "MANDAL",
    VILLAGE : "VILLAGE",
    PANCHAYATH: "PANCHAYATH",
    MITANK : "MITANK",
    BASIN: "BASIN",
    SUBBASIN: "SUBBASIN",
    STATION: "STATION",
    RESERVOIR: "RESERVOIR",
    RIVER_GAUGE: 'RIVER_GAUGE',
    WATERAUDIT: 'WATERAUDIT',
    MI_TANKS: 'Minor Irrigation Tanks',
    RIVERPOINT: "River Authority",
    GROUNDWATER: "Ground Water",
    REGION: "REGION",
    RIVER: "RIVER",
    WC_STRUCTURE: 'Wc Structure',
    RAINFALL: "RAINFALL",
    WATERSHED:"WATERSHED"
  },
  DISTRICT_ORDER_ACTUAL_NAME:
    [
      "Thiruvananthapuram",
      "Kollam",
      "Pathanamthitta",
      "Alappuzha",
      "Kottayam",
      "Idukki",
      "Ernakulam",
      "Thrissur",
      "Palakkad",
      "Malappuram",
      "Kozhikode",
      "Wayanad",
      "Mahe",
      "Kannur",
      "Kasaragod"
    ],
  API_MAPPING: {
    BREADCRUMB: "locations/heirarchy",
    LOCATION_TYPES: "comm/getLocTypes",
    MITANK_COUNT: "nowcast/getNowcastMITankAlertCount"
  },
  PANE_LIST: [
    {
      name: 'elev',
    zindex: '10'
    },
    {
      name: 'base',
      zindex: '390'
    },
    {
      name: 'WA',
      zindex: '400'
    },
    {
      name: 'state',
      zindex: '401'
    },
    {
      name: 'district',
      zindex: '402'
    },
    {
      name: 'mandal',
      zindex: '403'
    },
    {
      name: 'taluk',
      zindex: '404'
    },
    {
      name: 'firka',
      zindex: '405'
    },
    {
      name: 'heatMap',
      zindex: '2'
    },
    {
      name: 'marker',
      zindex: '600'
    },
    {
      name: 'popUp',
      zindex: '602'
    },
    {
      name: 'depth',
      zindex: '610'
    },
    {
      name: 'popUpGeoJson',
      zindex: '803'
    },
    {
      name: 'mask',
      zindex: '700'
    },
    {
      name: 'names',
      zindex: '800'
    },
    {
      name: 'clusterMarker',
      zindex: '801'
    },
    {
      name: 'max',
      zindex: '900'
    }
  ],
  HEATMAP: {
    'ACTUAL': 'ACTUAL',
    'DEVIATION': 'DEVIATION',
    'FLUCTUATION_LY': 'FLUCTUATION_LY',
    'FLUCTUATION_WY': 'FLUCTUATION_WY'
  },
  DATEPICKER_DATE_FORMAT: {
    YEAR: 'yyyy',
    MONTH: 'yyyyMM',
    DAY: 'yyyyMMdd',
    SEASON: 'season',
    Realtime : 'Realtime',
    HOURLY : 'hhh',
  },
  DATE_FORMAT: {
    ['yyyy']: 'Yearly',
    ['yyyyMM']: 'Monthly',
    ['yyyyMMdd']: 'Daily',
    ['season']: "Season",
    ['Realtime'] : "REALTIME"
  }
};


export const LAYER_TYPES = {
  'TILE_LAYER': 'TILELAYER',
  'WMS_LAYER': 'WMS',
  'VECTOR_LAYER': 'VECTOR',
  'GEOJSON_LAYER': 'GEOJSON',
  'HEATMAP_LAYER': 'HEATMAP',
  'CLUSTER_LAYER' : 'CLUSTER'
};

export const LOCATIONS_ZOOM_RANGE = {
  [VisibilityMapConstants.LOCATIONS.STATE]: {
    MIN: 6,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.BASIN]: {
    MIN: 6,
    MAX: 9
  },
  [VisibilityMapConstants.LOCATIONS.DISTRICT]: {
    MIN: 6,
    MAX: 10
  },
  // [VisibilityMapConstants.LOCATIONS.MANDAL]: {
  //   MIN: 10,
  //   MAX: 18
  // },
  [VisibilityMapConstants.LOCATIONS.RESERVOIR_INITIAL]: {
    MIN: 6,
    MAX: 10
  },
  [VisibilityMapConstants.LOCATIONS.RESERVOIR_NEXTLEVEL]: {
    MIN: 8,
    MAX: 10
  },
  [VisibilityMapConstants.LOCATIONS.BLOCK]: {
    MIN: 10,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.TALUK]: {
    MIN: 10,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.FIRKA]: {
    MIN: 10,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.SUBBASIN]: {
    MIN: 9,
    MAX: 11
  },
  [VisibilityMapConstants.LOCATIONS.MITANK]: {
    MIN: 10,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.RAINFALL]: {
    MIN: 6,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.GROUNDWATER]: {
    MIN: 6,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.STATION]: {
    MIN: 11,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.BASIN_LAST_LEVEL]: {
    MIN: 10,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.COMMAND_AREA]: {
    MIN: 6,
    MAX: 8
  },
  [VisibilityMapConstants.LOCATIONS.SUB_COMMAND_AREA]: {
    MIN: 9,
    MAX: 10
  },
  [VisibilityMapConstants.LOCATIONS.COMMAND_DISTRICT]: {
    MIN: 10,
    MAX: 11
  },
  [VisibilityMapConstants.LOCATIONS.COMMAND_MANDAL]: {
    MIN: 12,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.VILLAGE]: {
    MIN: 11,
    MAX: 18
  },
  [VisibilityMapConstants.LOCATIONS.INFLOWFORECAST]: {
    MIN: 6,
    MAX: 20
  },
  [VisibilityMapConstants.LOCATIONS.HEATMAP]: {
    MIN: 5,
    MAX: 22
  }
};

export const LOCATION_UUID = {
  [VisibilityMapConstants.LOCATIONS.INDIA]: {
    UUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759'
  },
  [VisibilityMapConstants.LOCATIONS.TELANGANA]: {
    [VisibilityMapConstants.VIEWS.ADMIN]: {
      UUID: '927b67e9-a2aa-46e9-99bc-41cf8c502668'
    },
    [VisibilityMapConstants.VIEWS.BASIN]: {
      UUID: '46f6cde3-cb7a-4a6a-829f-22c68fa62d9e'
    }
  },
  [VisibilityMapConstants.LOCATIONS.GODAVARI]: {
    [VisibilityMapConstants.VIEWS.BASIN]: {
      UUID: '5ddb60ef-aede-46ab-b319-e8e9c36fd715'
    },
  },
  [VisibilityMapConstants.LOCATIONS.TAMILNADU]: {
    [VisibilityMapConstants.VIEWS.ADMIN]: {
      UUID: 'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'
    },
    [VisibilityMapConstants.VIEWS.BASIN]: {
      UUID: 'e98cd5b7-6556-4c0f-a778-3429e1c14a6b'
    },
  },
  [VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH]: {
    [VisibilityMapConstants.VIEWS.ADMIN]: {
      UUID: '6f86292b-dd9a-4987-bb8f-c3940263b349'
    },
    [VisibilityMapConstants.VIEWS.BASIN]: {
      UUID: '6f86292b-dd9a-4987-bb8f-c3940263b349'
    },
  }
};

export const LOCATIONS_LATLNG = {
  [VisibilityMapConstants.LOCATIONS.TELANGANA]: [17.638787196813762, 78.55861865667588],
  [VisibilityMapConstants.LOCATIONS.GODAVARI]: [18.387606552494625, 77.74710395866969],
  [VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH]: [16.2, 80.7],
  [VisibilityMapConstants.LOCATIONS.INDIA]: [17.8, 79.06],
  [VisibilityMapConstants.LOCATIONS.TAMILNADU]: [10.9574, 78.3380],
  [VisibilityMapConstants.LOCATIONS['ALL BASINS']]: [10.9574, 78.3380],

};

export const PROJECTUUID_LATLNG = {
  "76276ced-2daf-445c-b972-893976d7cca6" : [11.30700112620,77.38635542860],
  "8dfb3293-1819-42d4-b6c4-da1634becc3f" : [10.61850142060,79.55394950250]
}

export const LOCATIONS_ZOOM = {
  [VisibilityMapConstants.LOCATIONS.TELANGANA]: 7.50,
  [VisibilityMapConstants.LOCATIONS.GODAVARI]: 7.50,
  [VisibilityMapConstants.LOCATIONS.INDIA]: 7.50,
  [VisibilityMapConstants.LOCATIONS.TAMILNADU]: 7.50,
  [VisibilityMapConstants.LOCATIONS['ALL BASINS']]:7.50,
  [VisibilityMapConstants.LOCATIONS['ANDHRAPRADESH']]:7.50,
};

export const MAP_OPTIONS = {
  minZoom: 6,
  maxZoom: 18,
  zoomSnap: 0.50,
  zoomDelta:0.50,
  updateWhenZooming: true,
  updateWhenIdle: true,
  zoom: LOCATIONS_ZOOM[VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH],
  center: LOCATIONS_LATLNG[VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH],
  zoomControl: false,
  zoomAnimation: true,
  maxBounds: [
    [40, 66],
    [5, 99]
  ],
  maxBoundsViscosity: 1.0,
};

export const BASE_LAYER_LIST = {
  [LAYER_TYPES.TILE_LAYER]: [{
    name: "Open Street Map",
    displayName: "Open Street Map",
    layerServiceType: "TILELAYER",
    type: 'Base',
    view: 'Admin',
    url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    default_select: false,
    imagesrc: "./assets/imgs/maps/open-street.jpg",
    visible: false,
    options: {
      attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
      maxZoom: MAP_OPTIONS.maxZoom,
    },

  },
  // {
  //   name: "Bhuvan",
  //   displayName: "Bhuvan",
  //   layerServiceType: "TILELAYER",
  //   type: 'Base',
  //   view: 'Admin',
  //   url: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
  //   attribution: '<a href="http://nrsc.gov.in/">NRSC</a>Map data © All rights reserved. Powered by <img src="assets/img/footer-logo.png">',
  //   imagesrc: "./assets/imgs/maps/open-street.jpg",
  //   visible: false,
  //   default_select: false,
  //   transparent: false,
  // },
  // {
  //   name: "Stamen",
  //   displayName: "Stamen",
  //   layerServiceType: "TILELAYER",
  //   type: 'Base',
  //   view: 'Admin',
  //   default_select: false,
  //   imagesrc: "./assets/imgs/maps/base-map.jpg",
  //   visible: false,
  //   url: "https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png",
  //   options: {
  //     maxNativeZoom: MAP_OPTIONS.maxZoom,
  //     maxZoom: MAP_OPTIONS.maxZoom,
  //   }
  // },
  {
    name: "Carto",
    displayName: "Carto",
    layerServiceType: "TILELAYER",
    type: 'Base',
    view: 'Admin',
    default_select: false,
    visible: true,
    url: 'http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
    imagesrc: "./assets/imgs/maps/base-map.jpg",
    maxZoom: MAP_OPTIONS.maxZoom,
    // options: {
    //   maxZoom: MAP_OPTIONS.maxZoom,
    // }
  },
  {
    name: "Google Satellite",
    displayName: "Google Satellite",
    layerServiceType: "TILELAYER",
    type: 'Base',
    view: 'Admin',
    default_select: false,
    imagesrc: "./assets/imgs/maps/satellite.jpg",
    visible: false,
    url: 'http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}',
    maxZoom: MAP_OPTIONS.maxZoom,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    // options: {
    //   maxZoom: MAP_OPTIONS.maxZoom,
    //   subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    // }
  },
  //  {
  //   "name":  "Dark Gray Canvas",
  //   "displayName":  "Dark Gray Canvas",
  //   "layerServiceType": "TILELAYER",
  //   "default_select": false,
  //   type : 'Base',
  //   view : 'Admin',
  //   "imagesrc": "./assets/imgs/maps/dark-gray.jpg",
  //   'visible' : false,
  //   "url": "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
  //   "maxZoom": 20,
  //   "maxNativeZoom": 17,
  //   "base" : true,
  //   "attribution": "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors, &copy; <a href='https://carto.com/attributions'>CARTO</a>'",
  //   },
  //   {
  //     "name":  "Google Terrain",
  //     "displayName":  "Google Terrain",
  //     "layerServiceType": "TILELAYER",
  //     "default_select": false,
  //     type : 'Base',
  //     view : 'Admin',
  //     imagesrc: "./assets/imgs/maps/base-map.jpg",
  //     'visible' : false,
  //     "url": "http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
  //     "maxZoom": 20,
  //     "maxNativeZoom": 17,
  //     "subdomains":["mt0", "mt1", "mt2", "mt3"],
  //     "base" : true
  //     },
  ],
  // {
  //   "name": "Dark Google Satellite",
  //   "displayName": "Dark Google Satellite",
  //   "layerServiceType": "TILELAYER",
  //   "default_select": false,
  //   type : 'Base',
  //   view : 'Admin',
  //   "imagesrc": "./assets/imgs/maps/satellite.jpg",
  //   'visible' : false,
  //   'url': 'http://mt3.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
  //   'options': {
  //       'maxZoom':22,
  //       'subdomains'  : ['mt0','mt1','mt2','mt3'],
  //     }
  //   },
  [LAYER_TYPES.WMS_LAYER]: [
    // {
    //     name: "Irrigation Base Layer",
    //     displayName: "Irrigation Base Layer",
    //     key:"Irrigation Base Layer",
    //     layeroptions_name: "tamilnadu:tamilnadu_irrigation_base_layer",
    //     layerServiceType: "WMS",
    //     type: 'WMS',
    //     view: 'Admin',
    //     default_select: false,
    //     imagesrc: "./assets/imgs/maps/base-map.jpg",
    //     visible: false,
    //     url: urlConstants.AP_GEOSERVER_URL + 'tamilnadu/gwc/service/',
    //     options: {
    //       minZoom: MAP_OPTIONS.minZoom,
    //       maxZoom: MAP_OPTIONS.maxZoom,
    //       pane: 'base'
    //     }
    // },
  ],
};

export const COMMON_LAYER_LIST = {

  [VisibilityMapConstants.VIEWS.ALL]: {
    "State Names": {
      name: "State Names",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ALL,
      layeroptions_name: "HEATWAVE:ALL_INDIA_STATE",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
      layeroptions_show_on_selector: true,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:CoreWris_State_Boundary",
      type: "WMS",
      cql_filter: null,
      group: "labels",
    },
    // "SRTM_DEM_30": {
    //   name: "SRTM_30",
    //   visible: true,
    //   view:  VisibilityMapConstants.VIEWS.ALL,
    //   layeroptions_name: "kaleshwaram:SRTM_30",
    //   layeroptions_min_zoom:  LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
    //   layeroptions_max_zoom:  LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
    //   layeroptions_show_on_selector: true,
    //   layeroptions_pane: 'elev',
    //   type: "WMS",
    //   cql_filter: null,
    //   group: null,
    // },
    // "BASELAYER_METADATA": {
    //   name: "BASELAYER_METADATA",
    //   visible: false,
    //   view: VisibilityMapConstants.VIEWS.ALL,
    //   layeroptions_name: "kaleshwaram:baselayer_metadata",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
    //   layeroptions_show_on_selector: true,
    //   layeroptions_pane: 'elev',
    //   type: "WMS",
    //   cql_filter: null,
    //   group: null,
    // },
    "India Boundary": {
      name: "India",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ALL,
      layeroptions_name: "HEATWAVE:ALL_INDIA_STATE",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
      layeroptions_show_on_selector: false,
      layeroptions_pane: 'WA',
      layeroptions_styles: "HEATWAVE:kwaram_forecast_india_shadow",
      type: "WMS",
      cql_filter: null,
      group: "null"
    },
    "AP Flood Points Name": {
      name: "Flood Points Name",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ALL,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      hasLegend : true,
      legendName : 'alert_icons',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:heatwave_flood_points_names_new",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },
  },

  [VisibilityMapConstants.VIEWS.ADMIN]: {
    "AP State Boundary": {
      name: "State",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_STATE_BOUNDARY",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MAX,
      layeroptions_show_on_selector: false,
      layeroptions_pane: 'WA',
      layeroptions_styles: "HEATWAVE:state_boundary",
      type: "WMS",
      cql_filter: null,
      group: "boundaries"
    },
    "AP District Name": {
      name: "District Names",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_DISTRICTS",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'marker',
      layeroptions_styles: "HEATWAVE:heatwave_district_short_names",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },
    "AP Mandal Name": {
      name: "Mandal Names",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_MANDAL",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'marker',
      layeroptions_styles: "HEATWAVE:heatwave_ap_mandal_names_style",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },
    // "TN Village Name": {
    //   name: "Village Name",
    //   visible: true,
    //   view: VisibilityMapConstants.VIEWS.ADMIN,
    //   dashboardView: VisibilityMapConstants.LOCATIONS.TAMILNADU,
    //   layeroptions_name: "tamilnadu:tamilnadu_village_names",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.VILLAGE].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.VILLAGE].MAX,
    //   layeroptions_show_on_selector: false,
    //   // layeroptions_pane: 'district',
    //   layeroptions_pane: 'names',
    //   layeroptions_styles: "tamilnadu:tamilNadu_village_names",
    //   type: "WMS",
    //   group: "labels",
    //   cql_filter: null,
    // },
    "AP District Boundaries": {
      source: 'District',
      displayName: "District",
      name: "DISTRICT",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_DISTRICTS",
      layer_name: "AP District Boundaries",
      layeroptions_pane: "state",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MAX,
      group: "boundaries",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      cqlfilter: null,
      type: "VECTOR",
    },
    "AP Mandal Boundaries": {
      source: 'Mandal',
      displayName: "Mandal", // mandal boundaries
      name: "MANDAL",
      visible: true,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_MANDAL",
      layer_name: "AP Mandal Boundaries",
      layeroptions_pane: "district",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MAX,
      group: "boundaries",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      type: "VECTOR",
    },
    "AP Basin Name": {
      name: "Basin Name",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_BASIN",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:heatwave_ap_basin_names",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },
    "AP Subbasin Name": {
      name: "Subbasin Name",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_SUBBASIN",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:heatwave_ap_subbasin_names",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },

    "AP Basin": {
      displayName: "Basin",
      name: "BASIN",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_BASIN",
      layer_name: "AP Basin",
      layeroptions_pane: "state",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MAX,
      group: "boundaries",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      type: "VECTOR",
    },
    "AP Subbasin": {
      displayName: "Sub Basin",
      name: "SUBBASIN",
      visible: false,
      view: VisibilityMapConstants.VIEWS.ADMIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_SUBBASIN",
      layer_name: "AP Subbasin",
      layeroptions_pane: "district",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MAX,
      group: "boundaries",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      type: "VECTOR",
    }
    
    // "TN Village Boundaries": {
    //   source: 'TELANGANA',
    //   displayName: "Village",
    //   name: "VILLAGE",
    //   visible: true,
    //   view: VisibilityMapConstants.VIEWS.ADMIN,
    //   dashboardView: VisibilityMapConstants.LOCATIONS.TAMILNADU,
    //   layerptions_show_on_selector: false,
    //   layeroptions_name: "tamilnadu:tamilnadu_villages",
    //   layer_name: "Telangana Village Boundaries",
    //   layeroptions_pane: "mandal",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.VILLAGE].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.VILLAGE].MAX,
    //   group: "boundaries",
    //   group_type: "radio-deselect",
    //   layerServiceType: "VECTOR",
    //   type: "VECTOR",
    // }

  },
  [VisibilityMapConstants.VIEWS.BASIN]: {
    "AP Basin Name": {
      name: "Basin Name",
      visible: true,
      view: VisibilityMapConstants.VIEWS.BASIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_BASIN",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:heatwave_ap_basin_names",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },
    "AP Subbasin Name": {
      name: "Subbasin Name",
      visible: false,
      view: VisibilityMapConstants.VIEWS.BASIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layeroptions_name: "HEATWAVE:AP_SUBBASIN",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MAX,
      layeroptions_show_on_selector: false,
      // layeroptions_pane: 'district',
      layeroptions_pane: 'names',
      layeroptions_styles: "HEATWAVE:heatwave_ap_subbasin_names",
      type: "WMS",
      group: "labels",
      cql_filter: null,
    },

    "AP Basin": {
      source: 'TELANGANA',
      displayName: "Basin",
      name: "BASIN",
      visible: true,
      view: VisibilityMapConstants.VIEWS.BASIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_BASIN",
      layer_name: "AP Basin",
      layeroptions_pane: "state",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BASIN].MAX,
      group: "basin",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      type: "VECTOR",
    },
    "AP Subbasin": {
      source: 'TELANGANA',
      displayName: "Sub Basin",
      name: "SUBBASIN",
      visible: true,
      view: VisibilityMapConstants.VIEWS.BASIN,
      dashboardView: VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_SUBBASIN",
      layer_name: "AP Subbasin",
      layeroptions_pane: "district",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.SUBBASIN].MAX,
      group: "basin",
      group_type: "radio-deselect",
      layerServiceType: "VECTOR",
      type: "VECTOR",
    }
  },
};

export const LAYER_LIST = {
  [VisibilityMapConstants.LOCATIONS.ANDHRAPRADESH] : {
    // "AP Rivergauge Point": {
    //   component: VisibilityMapConstants.COMPONENT['RAINFALL'],
    //   source: VisibilityMapConstants.SOURCES.ALL,
    //   view: VisibilityMapConstants.VIEWS.ALL,
    //   layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
    //   displayName:'Rivergauge Points',
    //   name: 'Rivergauge',
    //   visible: true,
    //   layerptions_show_on_selector: false,

    //   layeroptions_name: "HEATWAVE:tamilnadu_rivergauge_points_v4",
    //   layer_name: "AP Gauge Points",
    //   layeroptions_pane: "popUp",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
    //   hasLegend : true,
    //   legendName : VisibilityMapConstants.COMPONENT.RIVER_GAUGE,
    //   group: "rivergauge",
    //   pointToLayer:'addRivergaugeMarkerLayer',
    //   group_type: "radio-deselect",
    //   layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
    //   cqlfilter: null,
    //   type: LAYER_TYPES.GEOJSON_LAYER,
    // },
    // "AP Reservoir Point": {
    //   component: VisibilityMapConstants.COMPONENT['RAINFALL'],
    //   source: VisibilityMapConstants.SOURCES.ALL,
    //   view: VisibilityMapConstants.VIEWS.ALL,
    //   layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
    //   displayName:'Reservoir Points',
    //   name: 'Rivergauge',
    //   visible: true,
    //   layerptions_show_on_selector: false,

    //   layeroptions_name: "HEATWAVE:tamilnadu_rivergauge_points_v4",
    //   layer_name: "AP Gauge Points",
    //   layeroptions_pane: "popUp",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
    //   hasLegend : true,
    //   legendName : VisibilityMapConstants.COMPONENT.RIVER_GAUGE,
    //   group: "rivergauge",
    //   pointToLayer:'addRivergaugeMarkerLayer',
    //   group_type: "radio-deselect",
    //   layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
    //   cqlfilter: null,
    //   type: LAYER_TYPES.GEOJSON_LAYER,
    // },
    "Reservoirs": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs',
      name: 'Reservoirs',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'no_data',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Reservoirs in Normal": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs in Normal',
      name: 'Reservoirs in Normal',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'normal',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Reservoirs in Caution": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs in Caution',
      name: 'Reservoirs in Caution',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'caution',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Reservoirs in Warning": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs in Warning',
      name: 'Reservoirs in Warning',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'warning',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Reservoirs in Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs in Danger',
      name: 'Reservoirs in Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Reservoirs on Extreme Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Reservoirs on Extreme Danger',
      name: 'Reservoirs on Extreme Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'extreme_danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'no_data',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Normal Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'normal',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Caution Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'caution',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Warning Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'warning',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Danger Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "AP Extreme Danger Major Reservoir Points": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Major Reservoirs',
      name: 'Major Reservoirs',
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Major Reservoir Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "reservoir",
      pointToLayer:'majorReservoirPointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='RESERVOIR' or point_type='OS_RESERVOIR'",
      layerType:'extreme_danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges',
      name: 'River Gauges',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP RiverGauge  Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'no_data',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges in Normal": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges in Normal',
      name: 'River Gauges in Normal',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP RiverGauge Normal Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'normal',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges in Caution": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges in Caution',
      name: 'River Gauges in Caution',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Alert Caution RiverGauge Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'alertRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'caution',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges in Warning": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges in Warning',
      name: 'River Gauges in Warning',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Alert Warning RiverGauge Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'alertRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'warning',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges in Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges in Danger',
      name: 'River Gauges in Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Alert RiverGauge Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'alertRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "River Gauges in Extreme Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'River Gauges in Extreme Danger',
      name: 'River Gauges in Extreme Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_Floodforecast_points",
      layer_name: "AP Alert RiverGauge Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : false,
      // legendName : 'Flood_Alerts',
      group: "alerts",
      pointToLayer:'reservoirRiverGaugePointLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
      layerType:'extreme_danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities in Caution": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities in Caution',
      name: 'Cities in Caution',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "Cities in Caution",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'caution',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities in Warning": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities in Warning',
      name: 'Cities in Warning',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "AP City Warning Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'warning',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities in Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities in Danger',
      name: 'Cities in Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "AP City Danger Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities in Extreme Danger": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities in Extreme Danger',
      name: 'Cities in Extreme Danger',
      visible: true,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "AP City Extreme Danger Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'extreme_danger',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities in Normal": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities in Normal',
      name: 'Cities in Normal',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "AP City Normal Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'normal',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    "Cities": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:'Cities',
      name: 'Cities',
      visible: false,
      layerptions_show_on_selector: false,

      layeroptions_name: "HEATWAVE:AP_CITIES",
      layer_name: "AP City Points",
      layeroptions_pane: "popUpGeoJson",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      // hasLegend : true,
      // legendName : VisibilityMapConstants.COMPONENT.ALERT,
      group: "alerts",
      pointToLayer:'addRivergaugeMarkerLayer',
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      cqlfilter: null,
      layerType:'no_data',
      type: LAYER_TYPES.GEOJSON_LAYER,
    },
    // "AP MITank Point": {
    //   component: VisibilityMapConstants.COMPONENT['RAINFALL'],
    //   source: VisibilityMapConstants.SOURCES.ALL,
    //   view: VisibilityMapConstants.VIEWS.ALL,
    //   layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
    //   displayName:'MITank Points',
    //   name: 'MITank',
    //   visible: true,
    //   layerptions_show_on_selector: false,

    //   layeroptions_name: "HEATWAVE:AP_MITANKS",
    //   layer_name: "AP MITank Points",
    //   layeroptions_pane: "popUp",
    //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
    //   layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
    //   hasLegend : true,
    //   legendName : VisibilityMapConstants.COMPONENT.ALERT,
    //   group: "alerts",
    //   pointToLayer:'addRivergaugeMarkerLayer',
    //   group_type: "radio-deselect",
    //   layerServiceType: LAYER_TYPES.VECTOR_LAYER,
    //   cqlfilter: null,
    //   type: LAYER_TYPES.VECTOR_LAYER,
    // },
    "AP River Layer": {
      component: VisibilityMapConstants.COMPONENT['RAINFALL'],
      source: VisibilityMapConstants.SOURCES.ALL,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
      displayName:"River layer",
      name: "River layer",
      visible: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "HEATWAVE:AP_RIVER_NETWORK",
      layer_name: "AP River Layer",
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.RAINFALL].MAX,
      group: "alerts",
      pointToLayer:'',
      layeroptions_pane: "popUpGeoJson",
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      cqlfilter: null,
      cql_filter:"state='Andhra Pradesh'",
      type: LAYER_TYPES.WMS_LAYER,
    },
    "Heatmap Layer": {
      component: VisibilityMapConstants.COMPONENT.RAINFALL,
      source: VisibilityMapConstants.SOURCES.BACKEND,
      view: VisibilityMapConstants.VIEWS.ALL,
      layerFrom: VisibilityMapConstants.SOURCES.BACKEND,
      displayName: "Rainfall Heatmap Layer",
      name: "Rainfall Heatmap Layer",
      visible: true,
      hasLegend: true,
      layerptions_show_on_selector: false,
      layeroptions_name: "Rainfall Heatmap",
      layeroptions_pane: "heatMap",
      legendName: 'Rainfall Forecast',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.HEATMAP].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.HEATMAP].MAX,
      // key: "Rainfall Heatmap",
      group: "basin",
      group_type: "radio-deselect",
      layerServiceType: LAYER_TYPES.HEATMAP_LAYER,
      cqlfilter: null,
      type: LAYER_TYPES.HEATMAP_LAYER,
  },
  "MiTank District Structures Count": {
    component: VisibilityMapConstants.COMPONENT.RAINFALL,
    source: VisibilityMapConstants.SOURCES.ALL,
    view: VisibilityMapConstants.VIEWS.ADMIN,
    layerFrom: VisibilityMapConstants.SOURCES.GEOSERVER,
    displayName: "Tanks District Structures Count",
    name: "Tanks District Structures Count",
    visible: false,
    layerptions_show_on_selector: false,
    layeroptions_name: "HEATWAVE:heatwave_ap_district_points",
    layer_name: "mitanks_structure_count",
    layeroptions_pane: "popUp",
    layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MIN,
    layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.DISTRICT].MAX-1,
    // cType: [VisibilityMapConstants.LOCATIONS.DISTRICT],
    // paramType:'cType',
    group: "alerts",
    pointToLayer: 'addMITanksClusterLayer',
    group_type: "radio-deselect",
    layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
    cqlfilter: null,
    type: LAYER_TYPES.GEOJSON_LAYER,
  },
  // "MiTank_Mandal_Structures Count": {
  //   component: VisibilityMapConstants.COMPONENT.RAINFALL,
  //   source: VisibilityMapConstants.SOURCES.ALL,
  //   view: VisibilityMapConstants.VIEWS.ADMIN,
  //   layerFrom: VisibilityMapConstants.SOURCES.GEOSERVER,
  //   displayName: "Tanks Mandal Structures Count",
  //   name: "Tanks Mandal Structures Count",
  //   visible: true,
  //   layerptions_show_on_selector: false,
  //   layeroptions_name: "HEATWAVE:heatwave_ap_mandal_points",
  //   layer_name: "mitanks_mandal_structure_count",
  //   layeroptions_pane: "popUp",
  //   layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MIN,
  //   layeroptions_max_zoom: (LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN-1),
  //   // cType: [VisibilityMapConstants.LOCATIONS.DISTRICT],
  //   // paramType:'cType',
  //   group: "alerts",
  //   pointToLayer: 'addMITanksMandalClusterLayer',
  //   group_type: "radio-deselect",
  //   layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  //   cqlfilter: null,
  //   type: LAYER_TYPES.GEOJSON_LAYER,
  // },
  }
}

export const MITANK_MANDAL_CLUSTER :any ={
  "MiTank_Mandal_Structures Count": {
    component: VisibilityMapConstants.COMPONENT.RAINFALL,
    source: VisibilityMapConstants.SOURCES.ALL,
    view: VisibilityMapConstants.VIEWS.ADMIN,
    layerFrom: VisibilityMapConstants.SOURCES.GEOSERVER,
    displayName: "Tanks Mandal Structures Count",
    name: "Tanks Mandal Structures Count",
    visible: true,
    layerptions_show_on_selector: false,
    layeroptions_name: "HEATWAVE:heatwave_ap_mandal_points",
    layer_name: "mitanks_mandal_structure_count",
    layeroptions_pane: "popUp",
    layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.BLOCK].MIN,
    layeroptions_max_zoom: (LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN),
    // cType: [VisibilityMapConstants.LOCATIONS.DISTRICT],
    // paramType:'cType',
    group: "alerts",
    pointToLayer: 'addMITanksMandalClusterLayer',
    group_type: "radio-deselect",
    layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
    cqlfilter: null,
    type: LAYER_TYPES.GEOJSON_LAYER,
  },
}

export const MITANK_POLYGON_LAYER :any ={ 
  "Mitanks Polygon" : {
    component: VisibilityMapConstants.COMPONENT.RAINFALL,
    source: VisibilityMapConstants.SOURCES.ALL,        
    layerFrom: VisibilityMapConstants.SOURCES.GEOSERVER,
    displayName: "Tanks Polygon",
    name: "Tanks Polygon",
    visible: false,
    view: VisibilityMapConstants.VIEWS.ADMIN,
    layerptions_show_on_selector: false,
    layeroptions_name: "HEATWAVE:heatwave_ap_mitank_polygons",
    layer_name: "Tanks Polygons",
    layeroptions_pane: "popUp",
    layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.STATE].MIN,
    layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
    // cType: [VisibilityMapConstants.LOCATIONS.MITANK],
    // paramType:'cType',
    group: "alerts",
    hasLegend : false,
    // legendName : 'MI_TANKS_POLYGON',
    group_type: "radio-deselect",
    onEachFeature: 'addMITanksPolygonLayer',
    style: 'stylingforGeoJson',
    layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
    cqlfilter: null,
    type: LAYER_TYPES.GEOJSON_LAYER,
},
"Mitanks in Normal": {
  component: VisibilityMapConstants.COMPONENT['RAINFALL'],
  source: VisibilityMapConstants.SOURCES.ALL,
  view: VisibilityMapConstants.VIEWS.ALL,
  layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
  displayName:'Mitanks in Normal',
  name: 'Mitanks in Normal',
  visible: true,
  layerptions_show_on_selector: false,

  layeroptions_name: "HEATWAVE:AP_MITANKS",
  layer_name: "AP Mitank  Points",
  layeroptions_pane: "popUpGeoJson",
  layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN,
  layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
  // hasLegend : false,
  // legendName : 'Flood_Alerts',
  group: "alerts",
  pointToLayer:'mitanksPointLayer',
  group_type: "radio-deselect",
  layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  // cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
  layerType:'normal',
  type: LAYER_TYPES.GEOJSON_LAYER,
},
"Mitanks in Caution": {
  component: VisibilityMapConstants.COMPONENT['RAINFALL'],
  source: VisibilityMapConstants.SOURCES.ALL,
  view: VisibilityMapConstants.VIEWS.ALL,
  layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
  displayName:'Mitanks in Caution',
  name: 'Mitanks in Caution',
  visible: false,
  layerptions_show_on_selector: false,

  layeroptions_name: "HEATWAVE:AP_MITANKS",
  layer_name: "AP Alert Mitank Points",
  layeroptions_pane: "popUpGeoJson",
  layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN,
  layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
  // hasLegend : false,
  // legendName : 'Flood_Alerts',
  group: "alerts",
  pointToLayer:'mitanksPointLayer',
  group_type: "radio-deselect",
  layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  // cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
  layerType:'caution',
  type: LAYER_TYPES.GEOJSON_LAYER,
},
"Mitanks in Warning": {
  component: VisibilityMapConstants.COMPONENT['RAINFALL'],
  source: VisibilityMapConstants.SOURCES.ALL,
  view: VisibilityMapConstants.VIEWS.ALL,
  layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
  displayName:'Mitanks in Warning',
  name: 'Mitanks in Warning',
  visible: true,
  layerptions_show_on_selector: false,

  layeroptions_name: "HEATWAVE:AP_MITANKS",
  layer_name: "AP Alert Mitank Points",
  layeroptions_pane: "popUpGeoJson",
  layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN,
  layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
  // hasLegend : false,
  // legendName : 'Flood_Alerts',
  group: "alerts",
  pointToLayer:'mitanksPointLayer',
  group_type: "radio-deselect",
  layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  // cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
  layerType:'warning',
  type: LAYER_TYPES.GEOJSON_LAYER,
},
"Mitanks in Danger": {
  component: VisibilityMapConstants.COMPONENT['RAINFALL'],
  source: VisibilityMapConstants.SOURCES.ALL,
  view: VisibilityMapConstants.VIEWS.ALL,
  layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
  displayName:'Mitanks in Danger',
  name: 'Mitanks in Danger',
  visible: true,
  layerptions_show_on_selector: false,

  layeroptions_name: "HEATWAVE:AP_MITANKS",
  layer_name: "AP Alert Mitank Points",
  layeroptions_pane: "popUpGeoJson",
  layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN,
  layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
  // hasLegend : false,
  // legendName : 'Flood_Alerts',
  group: "alerts",
  pointToLayer:'mitanksPointLayer',
  group_type: "radio-deselect",
  layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  // cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
  layerType:'danger',
  type: LAYER_TYPES.GEOJSON_LAYER,
},
"Mitanks in Extreme Danger": {
  component: VisibilityMapConstants.COMPONENT['RAINFALL'],
  source: VisibilityMapConstants.SOURCES.ALL,
  view: VisibilityMapConstants.VIEWS.ALL,
  layerFrom :VisibilityMapConstants.SOURCES.GEOSERVER,
  displayName:'Mitanks in Extreme Danger',
  name: 'Mitanks in Extreme Danger',
  visible: true,
  layerptions_show_on_selector: false,

  layeroptions_name: "HEATWAVE:AP_MITANKS",
  layer_name: "AP Alert Mitank Points",
  layeroptions_pane: "popUpGeoJson",
  layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MIN,
  layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[VisibilityMapConstants.LOCATIONS.MITANK].MAX,
  // hasLegend : false,
  // legendName : 'Flood_Alerts',
  group: "alerts",
  pointToLayer:'mitanksPointLayer',
  group_type: "radio-deselect",
  layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
  // cqlfilter: "point_type='CANAL' or point_type='OS_CANAL'",
  layerType:'extreme_danger',
  type: LAYER_TYPES.GEOJSON_LAYER,
},
}

export const COMPONENT_ROUTE_MAPPING = {
  [VisibilityMapConstants.COMPONENT.RAINFALL]: 'rainfall',
  [VisibilityMapConstants.COMPONENT.ALERT]: 'alert',
};
